import {
    Button,
    Box,
    Paper,
    Menu,
    MenuItem,
    Container,
    Typography,
    Card,
    CardContent,
    CardHeader,
    Divider,
} from "@mui/material";

import Grid from "@mui/material/Unstable_Grid2/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Footer = ({ hasNext, hasBack, onNextClick, onBackClick, ...rest }) => {
    return (
        <Box>
            <Grid container spacing={2}>
                {hasBack && (
                    <Grid xs={5} item>
                        <Button
                            onClick={onBackClick}
                            startIcon={<ArrowBackIcon />}
                            color="secondary"
                            fullWidth
                            variant="outlined"
                            sx={{ height: "45px" }}
                        >
                            Back
                        </Button>
                    </Grid>
                )}

                {hasNext && (
                    <Grid xs={hasBack ? 7 : 12} item>
                        <Button
                            onClick={onNextClick}
                            color="primary"
                            fullWidth
                            variant="contained"
                            sx={{ height: "45px" }}
                            id="next-btn"
                        >
                            {rest.isPaymentScreen ? <>Pay now</> : <>Next</>}
                        </Button>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export { Footer };
